/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, invited: NonNullable<unknown> }} Invite_X15_Other_AccountInputs */

const en_invite_x15_other_account = /** @type {(inputs: Invite_X15_Other_AccountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You are signed in as ${i?.current}, but this invitation was sent to ${i?.invited}.`)
};

/** @type {(inputs: Invite_X15_Other_AccountInputs) => LocalizedString} */
const ar_invite_x15_other_account = en_invite_x15_other_account;

/** @type {(inputs: Invite_X15_Other_AccountInputs) => LocalizedString} */
const he_invite_x15_other_account = en_invite_x15_other_account;

/** @type {(inputs: Invite_X15_Other_AccountInputs) => LocalizedString} */
const ur_invite_x15_other_account = en_invite_x15_other_account;

/** @type {(inputs: Invite_X15_Other_AccountInputs) => LocalizedString} */
const es_invite_x15_other_account = en_invite_x15_other_account;

/** @type {(inputs: Invite_X15_Other_AccountInputs) => LocalizedString} */
const fr_invite_x15_other_account = en_invite_x15_other_account;

/** @type {(inputs: Invite_X15_Other_AccountInputs) => LocalizedString} */
const de_invite_x15_other_account = en_invite_x15_other_account;

/** @type {(inputs: Invite_X15_Other_AccountInputs) => LocalizedString} */
const pt_invite_x15_other_account = en_invite_x15_other_account;

/** @type {(inputs: Invite_X15_Other_AccountInputs) => LocalizedString} */
const hi_invite_x15_other_account = en_invite_x15_other_account;

/** @type {(inputs: Invite_X15_Other_AccountInputs) => LocalizedString} */
const bn_invite_x15_other_account = en_invite_x15_other_account;

/**
* | output |
* | --- |
* | "You are signed in as {current}, but this invitation was sent to {invited}." |
*
* @param {Invite_X15_Other_AccountInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_other_account = /** @type {((inputs: Invite_X15_Other_AccountInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Other_AccountInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_other_account(inputs)
	if (locale === "he") return he_invite_x15_other_account(inputs)
	if (locale === "ur") return ur_invite_x15_other_account(inputs)
	if (locale === "es") return es_invite_x15_other_account(inputs)
	if (locale === "fr") return fr_invite_x15_other_account(inputs)
	if (locale === "de") return de_invite_x15_other_account(inputs)
	if (locale === "pt") return pt_invite_x15_other_account(inputs)
	if (locale === "hi") return hi_invite_x15_other_account(inputs)
	if (locale === "bn") return bn_invite_x15_other_account(inputs)
	return en_invite_x15_other_account(inputs)
});